import { render, staticRenderFns } from "./WlReportsOverview.vue?vue&type=template&id=7956e8dc&scoped=true"
import script from "./WlReportsOverview.vue?vue&type=script&lang=js"
export * from "./WlReportsOverview.vue?vue&type=script&lang=js"
import style0 from "./WlReportsOverview.vue?vue&type=style&index=0&id=7956e8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7956e8dc",
  null
  
)

export default component.exports